import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import {
  CurrentUserHasLiveAuctionsQuery,
  CurrentUserHasLiveAuctionsQueryVariables,
} from './__generated__/useCurrentUserHasLiveAuctions.graphql';

const CURRENT_USER_HAS_LIVE_AUCTIONS_QUERY = gql`
  query CurrentUserHasLiveAuctionsQuery($sport: Sport!) {
    currentUser {
      slug
      involvedLiveTokenAuctions(sport: [$sport], first: 1) {
        totalCount
      }
    }
  }
` as TypedDocumentNode<
  CurrentUserHasLiveAuctionsQuery,
  CurrentUserHasLiveAuctionsQueryVariables
>;

export const useCurrentUserHasLiveAuctions = () => {
  const { sport = Sport.FOOTBALL } = useSportContext();
  const { data } = useQuery(CURRENT_USER_HAS_LIVE_AUCTIONS_QUERY, {
    variables: { sport },
    nextFetchPolicy: 'cache-first',
  });
  return !!(
    (data?.currentUser?.involvedLiveTokenAuctions?.totalCount || 0) > 0
  );
};
